import { render, staticRenderFns } from "./Fenxiao.vue?vue&type=template&id=6ef4cc1c&scoped=true&"
import script from "./Fenxiao.vue?vue&type=script&lang=js&"
export * from "./Fenxiao.vue?vue&type=script&lang=js&"
import style0 from "./Fenxiao.vue?vue&type=style&index=0&id=6ef4cc1c&lang=scss&scoped=true&"
import style1 from "./Fenxiao.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef4cc1c",
  null
  
)

export default component.exports